import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { faqs } from "../../data/faqs";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full border-t border-navy/10 bg-white px-5 py-14 md:py-20" data-id="element-83" data-mp="2fy2ubshj21k2">
      <div className="mx-auto max-w-3xl" data-id="element-84" data-mp="2txlqdmx2dmg0">
        <SectionHeading title="Frequently asked questions" data-id="element-85" data-mp="2twaq3x2tuwtn" />
        <ul className="mt-8 space-y-2.5" data-id="element-86" data-mp="2pxboomgb1i6y">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} className={`overflow-hidden rounded-lg border transition-colors duration-150 ${isOpen ? "border-navy" : "border-navy/15"}`} data-id="element-87" data-mp="33n5bkz891se1" data-mpi={i}>
                <button type="button" aria-expanded={isOpen} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-4 py-3 text-left focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-navy/20" data-id="element-88" data-mp="3dlbar92o8kf7">
                  <span className="font-display text-sm font-extrabold text-navy md:text-base" data-id="element-89" data-mp="1hw3i3ktr97kz">{faq.question}</span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-navy transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-90" data-mp="1mv6qnf8y1vxp" />
                </button>
                <AnimatePresence initial={false} data-id="element-91" data-mp="1wskrw7maqe5f">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-92" data-mp="21k2v72bskqtk">
                      <div className="px-4 pb-4 text-sm text-navy/85" data-id="element-93" data-mp="2fj2j27rhd1oo">
                        {faq.answer.length > 1 ? <ul className="list-disc space-y-1 pl-5" data-id="element-94" data-mp="fie0w1zh63zw">{faq.answer.map(a => <li key={a} data-id="element-95" data-mp="aijcc5369qi0">{a}</li>)}</ul> : <p className="leading-relaxed" data-id="element-96" data-mp="agezuyr7jj64">{faq.answer[0]}</p>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}